// Rim Crew global app
(function(){
  'use strict';
  document.addEventListener('cart:updated', function(e){
    var bubble = document.querySelector('.wm-nav-bubble');
    var count = (e.detail && e.detail.cart && e.detail.cart.item_count) || 0;
    if (count > 0) {
      if (!bubble) {
        var cart = document.querySelector('.wm-nav-cart');
        if (cart) {
          bubble = document.createElement('span');
          bubble.className = 'wm-nav-bubble';
          cart.appendChild(bubble);
        }
      }
      if (bubble) bubble.textContent = count;
    } else if (bubble) {
      bubble.remove();
    }
  });
})();

// burger toggle
(function(){
  var b=document.querySelector('[data-wm-burger]'),m=document.querySelector('[data-wm-mobile-menu]');
  if(!b||!m)return;
  b.addEventListener('click',function(){
    var open=m.classList.toggle('is-open');
    b.classList.toggle('is-active',open);
    document.body.style.overflow=open?'hidden':'';
  });
  m.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){m.classList.remove('is-open');b.classList.remove('is-active');document.body.style.overflow='';})});
})();

(function(){
  document.querySelectorAll('.wm-footer-pills').forEach(function(g){
    g.querySelectorAll('.wm-footer-pill').forEach(function(p){
      p.addEventListener('click',function(e){
        e.preventDefault();
        var isCy=g.classList.contains('wm-footer-pills-cy');
        g.querySelectorAll('.wm-footer-pill').forEach(function(x){x.classList.remove('is-active','is-cy')});
        p.classList.add('is-active');
        if(isCy)p.classList.add('is-cy');
      });
    });
  });
})();
